import { render, staticRenderFns } from "./ImagesSpace.vue?vue&type=template&id=27d2ce88"
import script from "./ImagesSpace.vue?vue&type=script&lang=js"
export * from "./ImagesSpace.vue?vue&type=script&lang=js"
import style0 from "./ImagesSpace.vue?vue&type=style&index=0&id=27d2ce88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports